import History from '@/entities/History';

export default class ProductsTransformer {
  static transformOne(item) {
    return new History(item);
  }

  static transformList(items) {
    return items.map((e) => ProductsTransformer.transformOne(e));
  }
}
